// these constants also included in /stylesheets/index.scss
export const REM_MOBILE_BREAKPOINT = 75
export const REM_MIN_MOBILE_SIZE = 22.5
